/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeresponseagreed2Inputs */

const en_outcomeresponseagreed2 = /** @type {(inputs: Outcomeresponseagreed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agreed to fix the issue`)
};

const pt_outcomeresponseagreed2 = /** @type {(inputs: Outcomeresponseagreed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitou resolver`)
};

/**
* | output |
* | --- |
* | "Agreed to fix the issue" |
*
* @param {Outcomeresponseagreed2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeresponseagreed2 = /** @type {((inputs?: Outcomeresponseagreed2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeresponseagreed2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeresponseagreed2(inputs)
	return pt_outcomeresponseagreed2(inputs)
});
export { outcomeresponseagreed2 as "outcomeResponseAgreed" }